<template>
  <AddUser/>
</template>
<script>
import AddUser from 'place/management/addUser.vue'
export default {
    components:{
      AddUser
    }
}
</script>